// Analytics Utils

const BLACK_LIST = [
  'user',
  'password',
  'cvv',
  'expirationMonth',
  'expirationYear'
];

export function isBlackList(value, key) {
  return BLACK_LIST.some(item => {
    if (!value) {
      return true;
    }

    if (typeof key === 'string') {
      return key.includes(item);
    }

    return false;
  });
}

export function eventBoilerplate(event) {
  return {
    event
  };
}

export function reduxMiddlewareMapper(events) {
  return (store, action) => {
    const type = (action && action.type) || '';
    return eventBoilerplate(events[type]);
  };
}
